/**
 * Textos del cliente local de firma.
 *
 * Hasta 1.13.x esto alimentaba un banner que se dibujaba al ingresar a la aplicación, para todo
 * usuario con rol firmante. El equipo de testing de UBA reportó que confundía (issue UBA #58): el
 * aviso aparecía antes de que el usuario expresara ninguna intención de firmar, no se recalculaba
 * —había que recargar la página para sacarlo— y en más de una ocasión apareció con el cliente
 * corriendo. El aviso se movió al único momento en que la respuesta importa: cuando el usuario va
 * a firmar. Estos son los textos de ese momento.
 *
 * En español hardcodeado, consistente con el resto de la UI (no usa i18n).
 */
export const SIGNATURE_CLIENT_MESSAGES = {
  /**
   * Cliente no detectado, antes de firmar.
   *
   * Cubre los dos casos a propósito —no está corriendo, y no está instalado— porque desde el
   * navegador no se distinguen: `getLocalClientStatus()` devuelve `null` igual si el daemon está
   * apagado, si el puerto cambió, si CORS o Private Network Access cortan el preflight, o si hay
   * un proxy en el medio. Afirmar "no lo instalaste" sería mentirle a quien lo tiene andando.
   */
  daemonDown: (appName) =>
    `No se detecta el cliente local de firma. Si ya lo tenés instalado, abrilo con el token ` +
    `conectado y reintentá. Si todavía no lo instalaste, descargalo desde la página del cliente ` +
    `de firma de ${appName}.`,

  /** Salida a la página donde se descarga y se prueba el cliente. */
  clientPageCta: 'Ir a la página del cliente de firma',
  clientPagePath: '/cliente-firma',
};

export default SIGNATURE_CLIENT_MESSAGES;
